import React, { useState, useContext } from "react";
import useForm from "../../../../services/UseForm";
import validate from '../../../../validations/admin/basicInfo/locationValidate';
import '../../../../css/popUpForm.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { LocationContext } from "../location";

axios.defaults.baseURL = API;

function CreateLocation(props) {

    const {LocationList, setLocationList} = useContext(LocationContext);

    const handleInputChange = event => {
        const { name, value } = event.target;
        handleChange(name, value)
    };

    const handleInputLocationNameChange = event => {
        const { name, value } = event.target;
        handleChange(name, value)
        check(value);
    };

    const check = (params) => {
        const results = LocationList.filter((data) => {
            return data.LocationName.toLowerCase() === params.toLowerCase()
        });
        if (results.length > 0)
            handleChange("CheckLocationName", results[0].LocationName);
        else
            handleChange("CheckLocationName", "");
    }

    async function saveTutorial() {
        let token = localStorage.getItem("token");
        var data = {
            LocationName: values.LocationName,
            Tell: values.Tell,
            Address: values.Address,
        }
        await axios.post("/createLocation", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            var obj = {
                LocationID: response?.data?.insertId,
                LocationName: values.LocationName,
                Tell: values.Tell,
                Address: values.Address,
            }
            LocationList.push(obj);
            setLocationList(LocationList);
            localStorage.setItem("locationData", JSON.stringify(LocationList));
            ClearData();
            props.onClick(false);
        }).catch((err) => {
            console.log(err);
        });
    };

    const ClearData = () => {
        handleChange("LocationName", "");
        handleChange("Tell", "");
        handleChange("Address", "");
    }

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(saveTutorial, validate);

    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="popUpForm">
            <div className="popUpcontent">
                <div className="popUpHeader">
                    <span>ສ້າງສາຂາ</span>
                </div>
                <div className="popUpBody">
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="form-row">
                            <div className="form-group">
                                <span>ຊື່ສາຂາ</span>
                                <input className={`input form-control ${errors.LocationName && 'is-invalid'}`} type="text" name="LocationName" onChange={(e) => handleInputLocationNameChange(e)} value={values.LocationName || ''} required />
                                {errors.LocationName && (
                                    <p className="invalid-feedback">{errors.LocationName}</p>
                                )}
                            </div>
                            <div className="form-group">
                                <span>ເບີໂທ</span>
                                <input className={`input form-control ${errors.Tell && 'is-invalid'}`} type="text" name="Tell" onChange={(e) => handleInputChange(e)} value={values.Tell || ''} required />
                                {errors.Tell && (
                                    <p className="invalid-feedback">{errors.Tell}</p>
                                )}
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group">
                                <span>ທີ່ຢູ່</span>
                                <textarea className={`input form-control ${errors.Address && 'is-invalid'}`} type="text" name="Address" onChange={(e) => handleInputChange(e)} value={values.Address || ''} required />
                                {errors.Address && (
                                    <p className="invalid-feedback">{errors.Address}</p>
                                )}
                            </div>
                        </div>
                        <div className="popUpfooter">
                            <button type="submit" className="btn btn-primary">
                                ບັນທຶກ
                            </button>
                            <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger" data-dismiss="modal" aria-label="Close">
                                ກັບຄືນ
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateLocation;
